import { NavLink, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { FaBars, FaTimes, FaDownload } from "react-icons/fa";
import logo from "../logo.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleLinkClick = () => setIsOpen(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const percent = height > 0 ? (scrollTop / height) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, percent)));
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/about", label: "About Me" },
    { to: "/projects", label: "Projects" },
    { to: "/documents", label: "Docs" },
  ];

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-[60] h-[2px] bg-white/10">
        <div className="h-full bg-accent" style={{ width: `${progress}%` }} />
      </div>

      <nav className="fixed top-2 left-0 right-0 z-50 px-4 sm:px-6">
        <div className="mx-auto flex max-w-7xl items-center justify-between rounded-full border border-white/10 bg-[rgba(5,5,5,0.72)] px-3 py-2 backdrop-blur-md shadow-soft">
          <Link to="/" onClick={handleLinkClick} className="flex items-center gap-3">
            <img src={logo} alt="Kushal Neupane logo" className="h-8 w-8 rounded-full object-contain" />
            <span className="hidden text-sm font-semibold tracking-[0.2em] text-white/90 sm:inline-block">
              KUSHAL NEUPANE
            </span>
          </Link>

          <div className="hidden items-center gap-2 md:flex">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={handleLinkClick}
                className={({ isActive }) =>
                  `rounded-full px-3 py-2 text-sm transition ${
                    isActive ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/10 hover:text-white"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={handleLinkClick}
              className="ml-2 inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-4 py-2 text-sm font-medium text-accent transition hover:bg-accent hover:text-black"
            >
              <FaDownload size={12} />
              Contact
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white md:hidden"
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            {isOpen ? <FaTimes size={16} /> : <FaBars size={16} />}
          </button>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, x: "100%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "100%" }}
              transition={{ type: "spring", stiffness: 260, damping: 24 }}
              className="fixed inset-y-0 right-0 z-40 flex w-72 flex-col border-l border-white/10 bg-[rgba(5,5,5,0.97)] p-6 shadow-2xl md:hidden"
            >
              <div className="mb-8 flex items-center justify-between">
                <span className="text-sm font-semibold uppercase tracking-[0.3em] text-white/60">Navigate</span>
                <button onClick={() => setIsOpen(false)} aria-label="Close menu" className="rounded-full border border-white/10 p-2 text-white/70">
                  <FaTimes size={14} />
                </button>
              </div>

              <div className="flex flex-col gap-2">
                {links.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    onClick={handleLinkClick}
                    className={({ isActive }) =>
                      `rounded-2xl px-4 py-3 text-sm transition ${
                        isActive ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/10 hover:text-white"
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                ))}
                <Link to="/contact" onClick={handleLinkClick} className="mt-4 inline-flex items-center justify-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-4 py-3 text-sm font-medium text-accent">
                  <FaDownload size={12} />
                  Contact
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </>
  );
}
